export default __webpack_public_path__ + "static/top-622ce4b2945e24b04fd1c6e8b2e20222.jpg";